import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-box" }
const _hoisted_2 = { class: "multi-content" }
const _hoisted_3 = { class: "content-box code" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "content-box player" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Niemand", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import {onMounted, ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchData} from "../utils/FetchData";
	import {SortArrayByObjectKey} from "../utils/Sorting";
	import RaceCard from '../components/RaceCard.vue';
	import ModalWindow from '../components/ModalWindow.vue';
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';
	import FetchOptions from "../interfaces/FetchOptions";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'EditSeasonPage',
  setup(__props) {

	const router = useRouter();
	const season = ref({});
	const circuits = ref([]);
	const loading = ref(true);

	const deletingRace = ref({
		circuit: {
			country: "",
			circuit: ""
		}
	});
	const modalVisible = ref(false);

	onMounted(() => {
		const query = router.currentRoute.value.query;
		if(query.id == undefined)
			return;

		const id = parseInt(query.id);
		if(id <= 0)
			return;

		retrieveSeason(id);
		retrieveCircuits();
	});

	async function retrieveSeason(id: number) {
		const data = await FetchData("seasons/" + id);
		if(data.isError) {
			const route = router.currentRoute.value;
			router.replace(route.path);
			return;
		}

		setSeason(data.data);
		loading.value = false;
	}

	async function retrieveCircuits() {
		const data = await FetchData('circuits');
		if(!data.isError)
			circuits.value = SortArrayByObjectKey(data.data, 'name');
	}

	async function saveSeason() {
		const body = season.value;
		delete body.players;
		delete body.races;

		if(body.id != undefined) {
			const options: FetchOptions = {
				method: 'PATCH',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};
			const data = await FetchData("seasons/" + season.value.id, options);
			if(!data.isError) {
				emitter.emit('showMessage', {message: 'Seizoen opgeslagen', header: 'Gelukt'});

				setSeason(data.data);
			}
		}
		else {
			const options: FetchOptions = {
				method: 'POST',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};
			const data = await FetchData("seasons", options);
			if(data.isError)
				return;

			emitter.emit('showMessage', {message: 'Seizoen toegevoegd', header: 'Gelukt'});
			router.replace({path: '/admin/edit', query: {id: data.data.id}});

			setSeason(data.data);
		}
	}

	function setSeason(seasonData: object) {
		seasonData.races = SortArrayByObjectKey(seasonData.races, 'date');
		season.value = seasonData;
		const privileges = seasonData.players.filter(x => x.pivot.privileges == 1);
		if(privileges.length == 0)
			season.value.privileges = 0;
		else
			season.value.privileges = privileges[0].id;
	}

	function copyCode() {
		const domain = window.location.host;
		const code = season.value.code;
		const text = `${domain}/invite/${code}`;
		navigator.clipboard.writeText(text)
		.catch((error) => {
			alert.error(`Could not copy text: ${error}`);
		});
	}

	function editDrivers() {
		router.push({path: '/admin/edit/drivers'});
	}

	function editCircuits() {
		router.push({path: '/admin/edit/circuits'});
	}

	function addRace() {
		season.value.races.unshift({
			date: (Date.now() / 1000) + new Date().getTimezoneOffset() * 60 * -1,
			drivers: []
		});
	}

	function onDeleteRace(race: object) {
		if(race.id == undefined) {
			season.value.races.shift();
			return;
		}

		deletingRace.value = race;
		modalVisible.value = true;
	}

	async function confirmAccept() {
		modalVisible.value = false;

		const options: FetchOptions = {
			method: 'DELETE'
		};
		const data = await FetchData("races/" + deletingRace.value.id, options);
		if(!data.isError)
			season.value.races = season.value.races.filter(x => x.id != deletingRace.value.id);
	}

	function confirmDeny() {
		modalVisible.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Naam seizoen",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((season.value.name) = $event))
      }, null, 512), [
        [_vModelText, season.value.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Code "),
        _createElementVNode("input", {
          type: "text",
          value: season.value.code,
          readonly: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("button", {
          class: "emoji",
          title: "Kopiëren naar klembord",
          onClick: copyCode
        }, " 📋 ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(" Speciale rechten "),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((season.value.privileges) = $event))
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(season.value.players, (player) => {
            return (_openBlock(), _createElementBlock("option", {
              key: player,
              value: player.id
            }, _toDisplayString(player.name), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, season.value.privileges]
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: saveSeason
    }, " Opslaan "),
    _hoisted_8,
    _createElementVNode("button", {
      class: "content-box",
      onClick: editDrivers,
      disabled: loading.value
    }, " Coureurs bewerken ", 8, _hoisted_9),
    _createElementVNode("button", {
      class: "content-box",
      onClick: editCircuits,
      disabled: loading.value
    }, " Circuit toevoegen ", 8, _hoisted_10),
    _createElementVNode("button", {
      class: "content-box",
      onClick: addRace,
      disabled: loading.value
    }, " Race toevoegen ", 8, _hoisted_11),
    _hoisted_12,
    (!loading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(season.value.races, (race) => {
          return (_openBlock(), _createBlock(RaceCard, {
            key: race,
            race: race,
            admin: true,
            season: season.value.id,
            players: undefined,
            predictions: undefined,
            circuits: circuits.value,
            onDeleteRace: onDeleteRace
          }, null, 8, ["race", "season", "circuits"]))
        }), 128))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Bevestigen ")
      ]),
      content: _withCtx(() => [
        _createTextVNode(" Weet je zeker dat je de race '" + _toDisplayString(deletingRace.value.circuit.country) + " - " + _toDisplayString(deletingRace.value.circuit.circuit) + "' en alle bijbehorende gegevens wilt verwijderen? ", 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: confirmAccept }, "Ja"),
        _createElementVNode("button", { onClick: confirmDeny }, "Nee")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalVisible.value]
    ])
  ], 64))
}
}

})